import React from 'react';
import { useChartContext } from '../../ChartContext';
import ChartOptionsDropdown from '../../ChartOptionsDropdown';
import FullScreenToggle from '../FullScreenToggle';
import CopyChartLinkButton from './CopyChartLinkButton';
import { ChartViewType, ChartMode } from '../../types';
import CentralChartSettingToggle from '../CentralChartSettingToggle';
import { ChartHeaderIconWrapper } from '../ChartHeaderUI';
import { CENTRAL_CHART_SETTING_VISIBLE_CONFIG } from '../../CentralChartSetting/hooks/utils';

const ChartHeaderIconActions = () => {
  const {
    metadata: {
      analysisId,
      chartView,
      chartOptionsEnabled,
      reportLink,
      isEmbedded,
      mode,
      queryType,
    },
  } = useChartContext();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const allowFullScreen =
    chartView.type === ChartViewType.Default && !isEmbedded;

  // only show copy chart link icon button in view mode
  // since we have a new share pill button in build mode that
  // already has a copy chart link button
  const showCopyChartLinkIconButton = mode === ChartMode.View && !isEmbedded;
  const showCentralChartSettingIconButton =
    CENTRAL_CHART_SETTING_VISIBLE_CONFIG[queryType] && mode === ChartMode.Build;
  return (
    <>
      {allowFullScreen && <FullScreenToggle />}
      {showCopyChartLinkIconButton && (
        <CopyChartLinkButton reportLink={reportLink} />
      )}
      {showCentralChartSettingIconButton && <CentralChartSettingToggle />}
      <ChartHeaderIconWrapper
        size={24}
        onClick={handleClick}
        isDisabled={!chartOptionsEnabled}
      >
        <ChartOptionsDropdown
          analysisId={analysisId}
          isDisabled={!chartOptionsEnabled}
        />
      </ChartHeaderIconWrapper>
    </>
  );
};

export default ChartHeaderIconActions;
